import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';

interface BaseOutlineColorPanelProps {
  strokeColor: RGBA;
  onUpdateStrokeColor(strokeColor: RGBA, undoable: boolean): void;
}

export function BaseOutlineColorPanel({...props}: BaseOutlineColorPanelProps): ReactElement<any> {
  const updateStrokeColor = (strokeColor: RGBA, undoable = true): void => {
    props.onUpdateStrokeColor(strokeColor, undoable);
  };

  const onChangeOutlineColor = (updatedColor: ColorStorage[]): void => {
    updateStrokeColor(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };

  const onChangeOutlineEnded = (updatedColor: ColorStorage[]): void => {
    updateStrokeColor(getRGBAArrayFromColorStorage(updatedColor)[0]);
  };
  return (
    <PosterEditingBaseColorPanel
      id="item-outline-color-panel"
      color={getColorObjectArrayFromFillColor([props.strokeColor])}
      onChangeColor={onChangeOutlineColor}
      onChangeEnded={onChangeOutlineEnded}
      isGradientEnabled={false}
    />
  );
}
